import {useI18n} from "vue-i18n";

export default{
    name: "DataRange",
    setup() {
        const { t } = useI18n({
            inheritLocale: true,
            useScope: 'local'
        })

        return { t }
    },
}
